import fileService from 'common/services/file-service/file.service';
import { UploadFileTypes } from 'common/services/file-service/file.service.types';

export const resizeImage = (blob: Blob, maxWidth = 1920, maxHeight = 1080): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const imageUrl = URL.createObjectURL(blob);

    img.onload = () => {
      let { width, height } = img;

      if (width <= maxWidth && height <= maxHeight) {
        URL.revokeObjectURL(imageUrl);
        resolve(blob);
        return;
      }

      const ratio = Math.min(maxWidth / width, maxHeight / height);

      const newWidth = Math.round(width * ratio);
      const newHeight = Math.round(height * ratio);

      const canvas = document.createElement('canvas');
      canvas.width = newWidth;
      canvas.height = newHeight;

      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Canvas context not available'));
        return;
      }

      ctx.drawImage(img, 0, 0, newWidth, newHeight);

      canvas.toBlob(
        (resizedBlob) => {
          URL.revokeObjectURL(imageUrl);

          if (!resizedBlob) {
            reject(new Error('Failed to resize image'));
            return;
          }

          resolve(resizedBlob);
        },
        blob.type,
        0.9,
      );
    };

    img.onerror = reject;
    img.src = imageUrl;
  });
};

export const getFile = async (url: string, fileType: UploadFileTypes) => {
  const blob = await fileService.getFile(url, fileType);

  const resizedBlob = await resizeImage(blob);

  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(resizedBlob);
  });
};
